function distFromRegion(item, x, defaultVal) {
  if (!item?.region) return defaultVal;
  if (x < item.region?.g0) return x - item.region.g0; // neg => left
  if (x > item.region?.g1) return x - item.region.g1; // pos => right
  return 0;
}

function binaryRegion(arr, val, compareFn) {
  const comparator = compareFn || distFromRegion;
  const maxAllowed = Math.log2(arr.length) + 1;
  let l = 0;
  let r = arr.length - 1;
  let i = Math.floor((r + l) / 2);
  let lDist;
  let xDist;
  let rDist;
  let lookLeft;
  let lookRight;
  let counter = 0;

  if (arr.length === 0) return null;
  if (arr.length === 1) return 0;

  while (counter < maxAllowed) {
    i = Math.floor((r + l) / 2);
    lDist = comparator(arr[i - 1], val, Infinity);
    xDist = comparator(arr[i + 0], val, Infinity);
    rDist = comparator(arr[i + 1], val, -Infinity);

    // search pos on the left, either left of the previous item or closer to the left than current.
    lookLeft = xDist < 0 && (lDist <= 0 || Math.abs(lDist) < Math.abs(xDist));
    lookRight = xDist > 0 && (rDist >= 0 || Math.abs(rDist) < Math.abs(xDist));

    if (l === r) return i;
    if (!lookLeft && !lookRight) return i;
    if (lookLeft) r = Math.max(i - 1, l);
    if (lookRight) l = Math.min(i + 1, r);
    counter += 1;
  }
  return null;
}

export default binaryRegion;
